export * from './callkitDataSlice';
export * from './selectors';

import { callkitDataReducer } from './callkitDataSlice';

export const callReducers = {
   callkitData: callkitDataReducer,
};
